import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock, X } from 'lucide-react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutos en segundos
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-118">
      <motion.div initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-red-600 to-pink-600 text-white shadow-lg" data-id="element-119">
        <div className="container mx-auto px-4 py-3" data-id="element-120">
          <div className="flex items-center justify-between gap-4" data-id="element-121">
            <div className="flex items-center gap-3 flex-1 justify-center" data-id="element-122">
              <Clock className="w-5 h-5 animate-pulse" data-id="element-123" />
              <span className="font-bold text-sm md:text-base" data-id="element-124">
                ⚡ ¡OFERTA TERMINA PRONTO!
              </span>
              <div className="bg-white/20 px-4 py-1 rounded-full font-mono font-bold text-lg" data-id="element-125">
                {String(minutes).padStart(2, '0')}:
                {String(seconds).padStart(2, '0')}
              </div>
            </div>
            <button onClick={() => setIsVisible(false)} className="text-white/80 hover:text-white transition-colors p-1" aria-label="Cerrar banner" data-id="element-126">
              <X className="w-5 h-5" data-id="element-127" />
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>;
}